export const SearchResults = {
  "pageName": "",
  "pageUrl": "",
  "SearchTerm": "",
  "SearchResults": "",
  "Search Category": "",
  "pageCategory": "",
};